import { createBrowserRouter, Outlet } from "react-router-dom";
import ErrorPage from "../error_page";
import PostsHome from "../all_posts";
import SinglePost from "../single_post";
import BlogHeader from "../blog_header";
import Shiny from "../shiny";

function Layout() {
  return (
    <>
      <BlogHeader />
      <main>
        <Outlet />
      </main>
    </>
  );
}


export function routerUtility({allPosts}) {
    let pages = [
      {
        path: "/parry_news/",
        element: <Layout/>,
        // element: <PostsHome allPosts={allPosts} />,
        children: [
          {
            path: "/parry_news/",
            element: <PostsHome allPosts={allPosts} />,
            errorElement: <ErrorPage />,
          },
          {
            path: "/parry_news/post/:postId",
            element: <SinglePost posts={allPosts} />,
            errorElement: <ErrorPage />,
          },
          {
            path: "/parry_news/shinies",
            element: <Shiny />,
            errorElement: <ErrorPage />,
          },
          {
            path: "/parry_news/*",
            error: <ErrorPage />,
          },
        ],
        errorElement: <ErrorPage />,
      },
      {
        path: "*",
        element: <Layout/>,
      }
    ];
  const router = createBrowserRouter(pages);
  return router;
}
